import React from 'react';
import { observer } from 'mobx-react';
import {
  RouteComponentProps, Switch, Route
} from "react-router-dom";
import IndexMikrotik from './IndexMikrotik';
import NewMikrotik from './NewMikrotik';
import ViewMikrotik from './ViewMikrotik';
import EditMikrotik from './EditMikrotik';

interface MikrotikProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class Mikrotik extends React.Component<MikrotikProps> {
  render() {
    const { path } = this.props.match;
    return (
      <Switch>
        <Route exact path={path}
          render={(props) => (
            <IndexMikrotik {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
        <Route exact path={`${path}/nuevo`}
          render={(props) => (
            <NewMikrotik {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
        <Route exact path={`${path}/ver/:id`}
          render={(props) => (
            <ViewMikrotik {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
        <Route exact path={`${path}/:id`}
          render={(props) => (
            <EditMikrotik {...props} changeToggle={this.props.changeToggle} />
          )}>
        </Route>
      </Switch>
    )
  }
}
